export const SUPPORTED_BROWSER_VERSIONS = [
    'chrome132',
    'safari17',
    'edge139',
    'firefox146',
    'ios17',
];
const VERSION_REGEX = /([a-zA-Z]+)(\d+)/;
const BROWSER_PATTERNS = [
    { pattern: /edg(?:e|ios|a)?\/([\d.]+)/i, name: 'Edge' },
    { pattern: /firefox\/([\d.]+)/i, name: 'Firefox' },
    { pattern: /opr\/([\d.]+)/i, name: 'Opera' },
    { pattern: /trident.*rv[: ]([\d.]+)/i, name: 'IE' },
    { pattern: / wv\).+chrome\/([\d.]+)/i, name: 'Chrome WebView' },
    { pattern: /(?:chrome|crios|crmo)\/([\d.]+)/i, name: 'Chrome' },
    { pattern: /version\/([\d.]+).*mobile.*safari/i, name: 'Mobile Safari' },
    { pattern: /version\/([\d.]+).*safari/i, name: 'Safari' },
];
/** @testonly - exported for testing */
export function _getBrowserName(ua) {
    if (!ua)
        return undefined;
    for (const { pattern, name } of BROWSER_PATTERNS) {
        if (pattern.test(ua))
            return name;
    }
    return undefined;
}
/** @testonly - exported for testing */
export function _getBrowserVersion(ua) {
    if (!ua)
        return undefined;
    for (const { pattern } of BROWSER_PATTERNS) {
        const match = ua.match(pattern);
        if (match?.[1])
            return match[1];
    }
    return undefined;
}
const BROWSER_VERSIONS = SUPPORTED_BROWSER_VERSIONS.reduce((acc, str) => {
    const match = str.match(VERSION_REGEX);
    if (match) {
        acc[match[1]] = +match[2];
    }
    return acc;
}, {});
function mapBrowserName(browserName) {
    const name = browserName.toLowerCase();
    if (name === 'chrome' || name === 'chromium' || name === 'chrome webview') {
        return 'chrome';
    }
    if (name === 'safari') {
        return 'safari';
    }
    if (name === 'mobile safari') {
        return 'ios';
    }
    if (name === 'edge') {
        return 'edge';
    }
    if (name === 'firefox') {
        return 'firefox';
    }
    return undefined;
}
/**
 * This is super loose since we don't wanna accidentally block users
 * @param ua
 * @returns
 */
export function isSupportedBrowser(ua) {
    try {
        const name = _getBrowserName(ua);
        if (!name) {
            return true;
        }
        const browserName = mapBrowserName(name);
        if (!browserName) {
            return true;
        }
        const minVersion = BROWSER_VERSIONS[browserName];
        if (!minVersion) {
            return true;
        }
        const version = _getBrowserVersion(ua);
        if (!version) {
            return true;
        }
        const majorVersionString = version.split('.')[0];
        if (!majorVersionString) {
            return true;
        }
        const majorVersion = parseInt(majorVersionString);
        if (isNaN(majorVersion)) {
            return true;
        }
        return majorVersion >= minVersion;
    }
    catch {
        return true;
    }
}
//# sourceMappingURL=supportedBrowsers.js.map